<template>
<div>
  <b-container v-if="solicitud" fluid>
    <h1>Recibir solicitud</h1>
    <b-card bg-variant="light" :title="solicitud.PersonalString.toUpperCase()">
      <item-lista-solicitud :item="solicitud"></item-lista-solicitud>
      <b-row>
        <b-col md="12" class="d-flex ">
          <b-button-toolbar aria-label="Barra de opciones">
            <b-button-group class="mx-1">
              <b-button variant="secondary" @click.stop="cerrarFormulario()">Volver</b-button>
            </b-button-group>
            <b-button-group class="mx-1" v-if="solicitud.EstadoSolicitudMedicaString === 'Enviado' || solicitud.EstadoSolicitudMedicaString == 'FueraTermino'">
              <b-button variant="success" v-if="isInRoleAdmin || isInRoleCoordinador" @click.stop="recibirSolicitud(solicitud, getEstablecimiento)" >Recibir solicitud</b-button>
            </b-button-group>
          </b-button-toolbar>
        </b-col>
      </b-row>
    </b-card>
    <tabla-cargo-personal :seleccionados="solicitud.ListaCargoPersonal_Id" :seleccionable="true"></tabla-cargo-personal>
  </b-container>
</div>
</template>

<script>
import swalerts from "@/helpers/swalerts";
import errorhandler from "@/helpers/errorhandler";
import { mapGetters,mapActions } from 'vuex'
import axios from 'axios';
import moment from 'moment';
import qs from 'qs';
import LicenciaCargoPersonalSvc from '@/services/licenciacargopersonal'
import PersonalSvc from '@/services/personal'
import Solicitudsvc from '@/services/solicitudes'
import CardDatosContacto from '../../common/CardDatosContacto'
import ItemListaSolicitud from '../../common/ListaSolicitudItem'
import TablaCargoPersonal from '../../common/TablaCargoPersonal'



import { createHelpers } from 'vuex-map-fields';



const { mapFields: mapFormSolicitudFields } = createHelpers({
  getterType: 'FormSolicitudModule/getSolicitudField',
  mutationType: 'FormSolicitudModule/updateSolicitudField',
});

const { mapFields: mapFormBuscarPersonalFields } = createHelpers({
  getterType: 'FormBuscarPersonal/getFormBuscarPersonalField',
  mutationType: 'FormBuscarPersonal/updateFormBuscarPersonalField',
});
export default {
  name: "RecibirSolicitudForm",
  mixins: [errorhandler, swalerts],
  components: { CardDatosContacto, ItemListaSolicitud, TablaCargoPersonal },
  computed: {
    ...mapFormBuscarPersonalFields(['Personal', 'ListaCargoPersonal', 'InputDni']),
    ...mapGetters(['getEstablecimiento','isInRoleAdmin','isInRoleCoordinador','isInRoleEstablecimiento','isInRoleRecMedico']),
    ...mapFormSolicitudFields(['TipoLicencia', 'DetalleDiasLicencia', 'EstadoSolicitudMedica', 'FechaDesde', 'Observaciones', 'CantidadDias', 'ListaCargoPersonalSeleccionado']),
  },
  props: {
    personal: Object,
    cargopersonal: Array
  },
  watch: {
  },
  data() {
    return {
      disabled: false,
      solicitud: null
    };
  },
  watch: {
  },
  mounted(){
    this.solicitud = this.$route.params.solicitud;
    this.buscarPersonal();
  },
  methods: {
    ...mapActions("SolicitudModule", ["cambiarEstado"]),
    buscarPersonal() {
      PersonalSvc.getPersonal({
        Id: this.solicitud.Personal_Id,
        IncluyeCargoPersonal: true,
        unidadeducativa_id: this.getEstablecimiento ? this.getEstablecimiento.UnidadEducativa_Id : 0,
        nivelenseñanza_id: this.getEstablecimiento ? this.getEstablecimiento.NivelEnseñanza_Id : 0
        }).then(response => {
          console.log('fin find personal', response);
          this.Personal = response.data.objeto;
          if (response.data.objeto.CargoPersonal.length > 0) {
            this.ListaCargoPersonal = response.data.objeto.CargoPersonal;
            this.ListaCargoPersonal = response.data.objeto.CargoPersonal;
          }

          this.disabled = false;
      })
      .catch(error => {
        if (error.response && error.response.status === 404) {
          this.showWarning('No se encontró el personal asociado a esta solicitud.');
        } else {
          this.errorHandler(error);
        }
        console.log('error buscarPersonal', error);
      });
    },
    recibirSolicitud(item) {
      console.log('recibirSolicitud', item, this.getEstablecimiento, this.ListaCargoPersonalSeleccionado);
      var ajustarPaginacion = true;
      this.showConfirmarInfo('Confirmar', `La solicitud ${item.Id} | ${this.ListaCargoPersonalSeleccionado} será recibida en ${this.getEstablecimiento.DisplayNivelAsignado}.`, 'Recibir')
      .then((willChange) => {
        console.log('then willChange', willChange);
        if (willChange.isConfirmed) {
          let qryparams = {
              id: item.Id,
              ListaCargoPersonal_Id: this.ListaCargoPersonalSeleccionado.slice(),
              estado: { value: 5, text: 'Recibido'},
              nivelenseñanza_id: this.getEstablecimiento.NivelEnseñanza_Id,
              unidadeducativa_id: this.getEstablecimiento.UnidadEducativa_Id,
              unidadadministrativa_id: this.getEstablecimiento.UnidadAdministrativa_Id,
          };
          this.cambiarEstado(qryparams)
            .then(response => {
              console.log('cambiarEstado then', response);
              this.showSuccess(response.data.status.mensaje);
              this.$router.push({ name: 'consultasolicitud', params: {  } });
            })
            .catch(error => {
              this.errorHandler(e);
            });
        }
      });
    },
    cerrarFormulario(mensaje){
      this.limpiarFormulario();
      if(mensaje){
        this.showSuccess(mensaje);
      }
      this.$router.push({ name: 'consultasolicitud', params: {  } });
    },
    limpiarFormulario()
    {
      this.ListaCargoPersonalSeleccionado = [];
    },
  }
}
</script>

<style >

</style>



// WEBPACK FOOTER //
// src/components/pages/solicitudes/RecibirSolicitudForm.vue